const o = (t = 0, {
  locale: n = "en-US",
  currency: m = "USD"
} = {}) => new Intl.NumberFormat(n, {
  style: "currency",
  currency: m
}).format(t), u = (t) => (t == null ? void 0 : t.min) !== (t == null ? void 0 : t.max) ? `${o(Number(t == null ? void 0 : t.min))} - ${o(Number(t == null ? void 0 : t.max))}` : o(t == null ? void 0 : t.min), f = (t = 0) => t == null || t === "" || typeof t != "number" ? 0 : t, r = (t = 0, n = 1) => t / n * 100, a = (t, n = 1) => t ? typeof t == "number" ? `${t.toFixed(n)}%` : `${Number(t).toFixed(n)}%` : "0.0%";
export {
  r as calcPercentage,
  o as formatCurrency,
  f as formatNumber,
  a as formatPercentage,
  u as getFormattedPrice
};
//# sourceMappingURL=numbers.es.js.map
